export var ACCESS_TOKEN_KEY = 'license_cancellation_access_token';
export var CURRENT_USER_KEY = 'license_cancellation_current_user';

export function getAccessToken() {
    return window.localStorage.getItem(ACCESS_TOKEN_KEY) || '';
}

export function setAccessToken(token) {
    if (!token) {
        return;
    }

    window.localStorage.setItem(ACCESS_TOKEN_KEY, token);
}

export function clearAccessToken() {
    window.localStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function getStoredUser() {
    var raw = window.localStorage.getItem(CURRENT_USER_KEY);

    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw);
    } catch (error) {
        return null;
    }
}

export function setStoredUser(user) {
    if (!user) {
        return;
    }

    window.localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(user));
}

export function clearStoredUser() {
    window.localStorage.removeItem(CURRENT_USER_KEY);
}

export function applyAuthorizationHeader(token) {
    if (!window.axios) {
        return;
    }

    if (token) {
        window.axios.defaults.headers.common.Authorization = 'Bearer ' + token;
    } else {
        delete window.axios.defaults.headers.common.Authorization;
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/auth.js